module.exports = __webpack_public_path__ + "static/media/logo1.cad71bc7.png";